import axios from "axios";
import React, { useEffect, useState } from "react"

/* icons */
import iconStarSingle from "../../images/icons/star_single.svg"

const Footer = (props) => {
    const [resources, setResources] = useState({});

    useEffect(() => {
        requestResources();
    }, [props.language]);

    const requestResources = () => {
        axios.get(`form/resources/${props.language}`).then((res) => {
            setResources(res.data.translation);
        });
    };

    return (
        <div className="footer-emmi">
            <div className="container page-container">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <img src={iconStarSingle} className="icon-star-footer-small" alt="" />
                        <img src={iconStarSingle} className="icon-star-footer" alt="" />
                        <img src={iconStarSingle} className="icon-star-footer-small" alt="" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12 text-center">
                        <span dangerouslySetInnerHTML={{ __html: resources?.Footer }}></span>
                    </div>
                </div>

                <div className="row text-center">
                    <p className="mt-4">
                        <small style={{ color: 'grey', fontSize: '11px' }}>powered by <a style={{ color: 'grey' }} href={resources?._TicketinoOrganizerUrl} target="_blank">TICKETINO</a></small>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
